import { Reveal, SectionHead } from "./shared";
import { CAPABILITIES } from "../data/content";

const CapabilityCard = ({ cap }) => (
    <Reveal className="h-full">
        <article
            data-testid={`capability-card-${cap.num}`}
            className="group relative h-full flex flex-col border border-vec-border bg-white hover:border-vec-green/40 transition-colors duration-500"
        >
            <div className="tech-frame relative overflow-hidden aspect-[16/10]">
                <img
                    src={cap.image}
                    alt={cap.alt}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.035]"
                />
                <span className="absolute top-3 left-3 bg-white/90 backdrop-blur px-2.5 py-1 font-mono-tech text-[9px] uppercase tracking-[0.22em] text-vec-green">
                    {cap.tag}
                </span>
            </div>
            <div className="relative flex flex-1 flex-col p-5 sm:p-7">
                <span className="absolute left-0 top-0 h-0 w-[2px] bg-vec-green-bright transition-all duration-500 group-hover:h-full" aria-hidden="true" />
                <div className="flex items-baseline justify-between">
                    <span className="font-mono-tech text-xs text-vec-charcoal/40">{cap.num}</span>
                    <span className="h-px w-8 bg-vec-border transition-colors duration-500 group-hover:bg-vec-green-bright" aria-hidden="true" />
                </div>
                <h3 className="mt-2 font-display text-xl sm:text-2xl font-semibold tracking-tight uppercase text-vec-charcoal leading-snug">
                    {cap.title}
                </h3>
                <ul className="mt-4 border-t border-vec-border flex-1">
                    {cap.items.map((item, i) => (
                        <li
                            key={item}
                            className="flex items-center gap-3 border-b border-vec-border py-2.5 text-sm text-vec-charcoal/70"
                        >
                            <span className="font-mono-tech text-[9px] tracking-wider text-vec-green/70">
                                {cap.num}.{i + 1}
                            </span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </article>
    </Reveal>
);

export const Capabilities = () => (
    <section id="capabilities" data-testid="capabilities-section" className="relative bg-vec-mist py-16 lg:py-32 tech-grid">
        <div className="vec-container">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                <SectionHead
                    index="SEC 02"
                    eyebrow="Capabilities"
                    title="From Engineering to Execution"
                    sub="Integrated capabilities across power transmission, substations, renewable energy and associated civil infrastructure."
                />
                <Reveal delay={0.2}>
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-vec-charcoal/45 lg:text-right">
                        04 Modules / Transmission — Substations — Renewable — Civil
                    </p>
                </Reveal>
            </div>

            <div className="mt-10 lg:mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                {CAPABILITIES.map((cap) => (
                    <CapabilityCard key={cap.num} cap={cap} />
                ))}
            </div>
        </div>
    </section>
);
